module.exports = __webpack_public_path__ + "media/assets/fonts/Verdana-Regular-5b0da4fe5677451d28a79aadf1d0bf18.ttf";